import { type HTMLAttributes } from 'react'
import { cn } from '../lib/cn'
import { TONE_CLASSES, type StatusTone } from '../status/registry'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: StatusTone
  variant?: 'soft' | 'solid' | 'outline'
}

export function Badge({ className, tone = 'neutral', variant = 'soft', ...props }: BadgeProps) {
  const toneClasses = TONE_CLASSES[tone]
  const variantClass =
    variant === 'solid'
      ? toneClasses.solid
      : variant === 'outline'
        ? cn('border', toneClasses.fg, 'bg-transparent border-current')
        : toneClasses.soft
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium',
        variantClass,
        className,
      )}
      {...props}
    />
  )
}
